import { render, staticRenderFns } from "./KitMetricChart.vue?vue&type=template&id=e96df9d0&scoped=true"
import script from "./KitMetricChart.vue?vue&type=script&lang=ts"
export * from "./KitMetricChart.vue?vue&type=script&lang=ts"
import style0 from "./KitMetricChart.vue?vue&type=style&index=0&id=e96df9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96df9d0",
  null
  
)

export default component.exports